// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export const fetchTierRewards = (workerID: number) => ({ type: types.WORKER_TIER_FETCH_BEGIN, workerID })
